export default "__VITE_ASSET__BLb9cmEo__"